import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SharedServiceService } from '../../services/shared-service.service';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-multi-language',
  templateUrl: './multi-language.component.html',
  styleUrls: ['./multi-language.component.css']
})
export class MultiLanguageComponent implements OnInit {

  constructor( public translate: TranslateService,
    private sharedservice:SharedServiceService,
    private notificationService: NotificationService){
  }
  switchLang() {
    this.translate.use(this.selectedlang);
    this.sharedservice.getDefaultLanguage('New',this.selectedlang);
  }

  ngOnInit(): void {
    this.getLanguagesList();
    
  }
  selectedlang:any="";
  languageList:any=[];
  dfltlangcall:boolean=false;
  dealerdetails:any;
  lnglist:any=[];
  async getLanguagesList(){
    const result :any =[]// await this.sharedservice.getLangSupported();
    if(result.STATUS_OUT=="SUCCESS"){
      this.lnglist=result.RESPONSE_OUT;
      for (let i = 0; i < result.RESPONSE_OUT.length; i++) {
        this.languageList.push(result.RESPONSE_OUT[i].codeDesc);
      }
      this.translate.addLangs(this.languageList);
      this.sharedservice.dealerDistDetails.subscribe((s:any)=>{
        if(s.length){
          this.dealerdetails=s[0].RESPONSE_OUT;
          if(!this.dfltlangcall){
            this.getdealerdistDefaultlanguage(s[0].RESPONSE_OUT);
            this.dfltlangcall=true;
          }
        }
      })
    }else{
      this.languageList.push("ENGLISH");
      this.translate.addLangs(this.languageList);
      this.selectedlang="ENGLISH";
      this.sharedservice.getDefaultLanguage('',this.selectedlang)
      this.translate.setDefaultLang(this.selectedlang);
    }
  }
async getdealerdistDefaultlanguage(dlrdt:any){
  const req :any = {
    distCode:dlrdt.dist_code!=""?dlrdt.dist_code:"",
    dealerCode:dlrdt.dlr_code!=""?dlrdt.dlr_code:"",
  }
  const result :any = []// await this.sharedservice.getDefaultdlrdistLanguage(req);
  if(result.STATUS_OUT=="SUCCESS"){
    this.selectedlang=result.RESPONSE_OUT[0].codeDesc;
    this.sharedservice.getDefaultLanguage('',this.selectedlang)
    this.translate.setDefaultLang(this.selectedlang);
  }
}
async upadtelanguage(){
  const lngcode=this.lnglist.filter((x:any)=>x.codeDesc==this.selectedlang);
  const req:any ={
    distCode:this.dealerdetails.dist_code!=""?this.dealerdetails.dist_code:"",
    dealerCode:this.dealerdetails.dlr_code!=""?this.dealerdetails.dlr_code:"",
    code:lngcode[0].code,
    codeDesc:this.selectedlang}
  const result :any = []// await this.sharedservice.upadtelanguage(req);
  if(result.STATUS_OUT== "SUCCESS"){
    this.notificationService.success(result.RESPONSE_OUT,"Close");
  }else{
    this.notificationService.error(result.RESPONSE_OUT,"Close");

  }
  
}
}
